import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { VerificationServiceChangeRequest } from "@idw-types/data/verification-service";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";

type UnsubmitVerificationServiceChangeRequestModalProps = {
    serviceName: string;
    apiKey: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<VerificationServiceChangeRequest>;
};

export const UnsubmitVerificationServiceChangeRequestModal = (props: UnsubmitVerificationServiceChangeRequestModalProps) => {
    const { serviceName, apiKey, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>UNSUBMIT</b> the Change Request for the Verification Service named <b>{serviceName}</b> with API Key <b>{apiKey}</b>.</p>
                <p>
                    The review of this Change Request will be canceled so that you may make further changes and then re-submit the change request at some point in the future.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.UNSUBMIT}
            title={"Unsubmit Verification Service Change Request"}
            body={bodyElement}
            buttonText={"Unsubmit Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};